/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const CompaniesListPage = lazy(() => import('./pages/list/CompaniesListPage'))
const CompanyDetailPage = lazy(() => import('./pages/detail/CompanyDetailPage'))

export const aziendeRoutes: RouteObject[] = [
  {
    path: 'aziende',
    element: <CompaniesListPage />,
  },
  {
    path: '/aziende/:companyId',
    element: <CompanyDetailPage />,
  },
]
